<template>
    <div class="page course-page">
        <div v-if="course" class="header" style="width: 100%" :class="{'pt-8': pcOnly}">
            <v-container class="pb-0" :class="{'pa-4': phoneOnly}">
                <div class="d-flex flex-column flex-lg-row">
                    <div>
                        <v-img :height="pcOnly ? 275 : 200" :width="pcOnly ? 400 : ''" :src="course.image_url" :style="`border-radius: ${pcOnly ? 15 : 10}px; overflow: hidden; position: relative;`">
                            <div class="pa-3" style="position: absolute; top: 0;">
                                <v-chip v-if="course.featured" color="orange darken-1" small dark class="me-lg-3">
                                    <v-icon size="18">mdi-star-outline</v-icon>
                                </v-chip>
                            </div>
                        </v-img>

                        <course-join-button v-if="pcOnly" :course="course" @join-dialog="joinDialog = true" />

                    </div>
                    <div class="px-lg-15 py-6 py-lg-4">
                        <div class="mb-4 mb-lg-5" :class="{'text-center': phoneOnly}">
                            <h1 v-if="pcOnly" class="font-weight-medium mb-3 mb-lg-0">{{course.name}}</h1>
                            <h3 v-else class="font-weight-medium mb-1 mb-lg-0">{{course.name}}</h3>
                        </div>
                        <div v-if="!course.joined" class="d-flex mb-lg-5 flex-wrap justify-center justify-lg-start">
                            <v-chip v-for="grade in course.grades" :key="grade.id" label :small="phoneOnly" class="me-1 me-lg-3 my-1 px-2">
                                <!-- <v-icon :size="phoneOnly ? 16 : 18" class="me-2">mdi-school</v-icon> -->
                                {{grade.name}}
                            </v-chip>
                            <template v-if="course.teachers && course.teachers.length">
                            <v-chip v-for="teacher in course.teachers" :key="'teacher-' + teacher.id" label :to="{name: 'teacher', params: {id: teacher.id}}" v-ripple="phoneOnly" :small="phoneOnly" class="me-1 me-lg-3 my-1 ps-1 pe-2">
                                <v-avatar v-if="teacher.avatar" tile class="me-2 rounded" :style="phoneOnly ? 'height: 18px!important; min-width: 18px!important; width: 18px!important;' : ''">
                                    <img :src="teacher.avatar">
                                </v-avatar>
                                {{teacher.name}}
                            </v-chip>
                            </template>
                            <v-chip v-for="category in course.categories" :key="category.id" :small="phoneOnly" label class="me-1 me-lg-3 my-1 px-2">
                                <!-- <v-icon :size="phoneOnly ? 16 : 18" class="me-2">mdi-book-outline</v-icon> -->
                                {{category.name}}
                            </v-chip>
                            <!-- <v-chip v-if="course.lectures_count" :small="phoneOnly" label outlined>
                                <v-icon size="16" left>mdi-play-box-multiple-outline</v-icon>
                                {{unitFormat(course.lectures_count, 'محاضرة', 'محاضرتين', 'محاضرات')}}
                            </v-chip> -->
                        </div>
                        
                        <div v-if="phoneOnly && !course.joined" class="mt-2 mb-5">
                            <course-join-button :course="course" @join-dialog="joinDialog = true" />

                        </div>

                        <div v-if="!course.joined || pcOnly" class="description-wrapper mt-4 my-lg-0 py-lg-0">
                            <p v-if="course.description" style="line-height: 2.2; white-space: pre-line;" class="medium-text text--text">
                                <span v-if="course.description.length < maxDescriptionLength" v-html="urlify(escapeHtmlText(course.description))"></span>
                                <span v-else>
                                    <span v-html="urlify(escapeHtmlText(showMoreDescription ? course.description : course.description.slice(0, maxDescriptionLength)))"></span><span v-if="!showMoreDescription">...</span>
                                    <a v-if="!showMoreDescription" text class="link--text ms-1" @click="showMoreDescription = true" style="white-space: nowrap">عرض المزيد</a>
                                    <a v-else text class="link--text ms-2" @click="showMoreDescription = false" style="white-space: nowrap">عرض أقل</a>
                                </span>
                            </p>
                        </div>
                    </div>
                    
                </div>
            </v-container>
        </div>
        <div v-if="course" class="mt-lg-8">
            <v-container class="py-lg-6 py-0" :class="{'px-0': phoneOnly}">
                <!-- <v-divider></v-divider> -->
                <div v-if="course.joined || (course.show_preview)">
                    <v-card class="py-2 py-lg-3 px-lg-5 lg:bordered" :flat="phoneOnly">
                        <v-card-title v-if="pcOnly">
                            <v-icon color="strong-text" class="me-2">mdi-play-box-multiple</v-icon>
                            المحاضرات
                            <span v-if="course.lectures_count" class="medium-text muted--text ms-1">({{course.lectures_count}})</span>
                        </v-card-title>
                        <v-card-text :class="{'pa-0': phoneOnly}">

                            <v-alert v-if="platform === 'web' && !miniDerasaPlatform && !wpEnabled" text dark color="primary" class="blink-animation" :class="phoneOnly ? 'ma-3 pa-4' : 'mb-3 px-5 py-3'">
                                <div class="d-flex align-center" :class="{'flex-column justify-center': phoneOnly, 'justify-space-between': pcOnly}">
                                    <div :class="{'text-center': phoneOnly}">
                                        قم بتحميل {{phoneOnly ? 'تطبيق الهاتف' : 'برنامج الديسكتوب'}} حتى تتمكن من مشاهدة المحاضرات
                                    </div>

                                    <div :class="{'ms-4': pcOnly, 'mt-2': phoneOnly}">
                                        <v-btn v-if="pcOnly" depressed :block="phoneOnly" color="primary" tag="a" download :href="appData.desktop_app_url">
                                            <v-icon size="20" class="ml-2" color="white">mdi-monitor</v-icon>
                                            تحميل البرنامج
                                        </v-btn>

                                        <div v-else class="store-badges d-flex align-center justify-start pa-0">
                                            <store-badge type="playstore" width="135px" />
                                            <store-badge type="appstore" width="106px" />
                                        </div>

                                    </div>
                                </div>
                            </v-alert>
                            <v-list v-if="courseLectures && courseLectures.length" two-line class="pa-0 transparent">
                                <template v-for="(lecture, i) in courseLectures" >
                                    <lecture-list-item :lecture="lecture" :pay_type="course.pay_type" :key="lecture.id" @sync="syncLecture" />
                                    <v-divider v-if="i <courseLectures.length -1" :key="'d' + i"></v-divider>
                                </template>
                            </v-list>
                            <div v-else>
                                <v-alert v-if="isAuthed" outlined text type="info" color="blue-grey" :dense="phoneOnly" class="mb-0 mx-4 mx-lg-0">
                                    <div class="strong-text--text" :class="{'medium-text': phoneOnly}">
                                        لم يتم إضافة محاضرات بعد!
                                    </div>
                                </v-alert>            
                            </div>
                        </v-card-text>
                    </v-card>
                </div>
                <v-card flat v-else class="pa-3 pa-lg-6 lg:bordered">
                    <v-alert v-if="isAuthed" outlined text color="primary" icon="mdi-book-plus-outline" class="mb-0">
                        <div class="strong-text--text">
                            يجب الانضمام للدورة أولاً لتصفح المحاضرات
                        </div>
                    </v-alert>
                    <v-alert v-else outlined text color="grey" class="mb-0">
                        <div class="strong-text--text d-flex align-center justify-lg-space-between">
                            <div>
                                <v-icon class="me-2">mdi-login-variant</v-icon>
                                يجب تسجيل الدخول أولاً للوصول إلى محتوى الدورة
                            </div>
                            <v-btn depressed color="strong-text" dark v-if="pcOnly" :to="{name: 'login', query: {course: course.id}}">
                                <v-icon left>mdi-login-variant</v-icon>
                                سجل الدخول اﻵن
                            </v-btn>
                        </div>
                    </v-alert>

                </v-card>
            </v-container>
        </div>
        <template v-if="course && !course.joined">
            <course-join-dialog v-if="course.pay_type === 'lectures'" v-model="joinDialog" :course="course" @joined="getCourse" />
            <course-purchase-dialog v-else v-model="joinDialog" :course="course" @purchased="getCourse"  />
        </template>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import InfinityWrapper from '@/components/default/infinity-wrapper'
import CourseJoinDialog from '@/components/custom/course-join-dialog'
import CoursePurchaseDialog from '@/components/custom/course-purchase-dialog'
import LectureListItem from '@/components/custom/lecture-list-item'
import StoreBadge from '@/components/default/store-badge'

import { PrivacyScreen } from '@capacitor-community/privacy-screen';
import CourseJoinButton from '@/components/custom/course-join-button.vue'

import * as linkify from 'linkifyjs';
import linkifyHtml from 'linkify-html';

export default {
    name: "Courses",
    components: {
        InfinityWrapper,
        LectureListItem,
        CourseJoinDialog,
        CoursePurchaseDialog,
        StoreBadge,
        CourseJoinButton,
    },
    data(){
        return {
            loading: false,
            course: null,
            courseLectures: null,

            showMoreDescription: false,

            joinDialog: false,
        }
    },
    computed: {
        ...GlobalComputed,
        id(){
            return this.$route.params.id;
        },
        maxDescriptionLength(){
            return this.pcOnly ? 350 : 200;
        }
    },
    methods: {
        ...GlobalMethods,
        getCourse(){
            if (!this.loading){
                this.loading = true;
                const url = '/courses/' + this.id;
                this.$store.dispatch('fastGetAction', {url}).then(response=>{
                    this.loading = false;
                    this.setDRM();
                    const course = response.data.data;
                    this.course = course;
                    this.courseLectures = course.lectures;
                    this.setDocumentTitle(course.name, true);

                }).catch(()=>{
                    this.showMsg('حدثت مشكلة أثناء تحميل الدورات');
                    this.loading = false;
                });
            }
        },
        syncLecture(lecture){
            this.courseLectures = this.courseLectures.map(item=>{
                if (item.id === lecture.id){
                    return Object.assign(item, lecture);
                }
                return item;
            })
        },
        setDRM(){
            if (this.platform === 'android'){
                return PrivacyScreen.enable();
            }
        },
        removeDRM(){
            if (this.platform === 'android'){
                return PrivacyScreen.disable();
            }
        },

        urlify(text){
            const options = { defaultProtocol: 'https' , target: '_system'};
            return linkifyHtml(text, options);
        },
        escapeHtmlText(text){
            // to prevent XSS attacks
            return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
        },
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        },
        id(){
            this.getCourse();
        }
    },
    mounted(){
        if (!this.course){
            this.getCourse();
        }
    },
    beforeDestroy(){
        this.removeDRM();
    }
};
</script>

<style lang="scss" scoped>
    @media(max-width: 960px){
        h1{
            line-height: 1.3;
            font-size: 1.8rem;
            font-weight: bold!important;
            text-align: center;
        }
    }
    @media(min-width: 960px){
        .header{
            .container{
                min-height: 270px;
            }
        }
    }
</style>
<style lang="scss">
.v-skeleton-loader__image{
    height: 150px!important;
}
</style>